module.exports = __webpack_public_path__ + "static/media/icono_malta.cefb5983.svg";